import { fetchAllCultureCourses, fetchCultureCourseInfo } from "@/api/landing";
import { generateRandomGradient } from "@/utils/gradients";

export default {
  namespaced: true,
  state: {
    allCultureCourses: {
      data: [],
      pagination: {
        currentPage: 1,
        total: 0,
        perPage: 10,
        lastPage: 1,
        nextPage: null,
      },
    },
    cultureCourseInfo: {},
    gradients: [],
  },

  mutations: {
    SET_ALL_CULTURE_COURSES(state, payload) {
      state.allCultureCourses.data = payload.data;
      state.allCultureCourses.pagination = {
        currentPage: payload.current_page,
        total: payload.total,
        perPage: payload.per_page,
        lastPage: payload.last_page,
        nextPage: payload.next_page_url,
      };

      if (
        state.gradients.length === 0 ||
        state.gradients.length !== payload.data.length
      ) {
        state.gradients = payload.data.map((_, index) =>
          generateRandomGradient(index)
        );
      }
    },
    SET_CULTURE_COURSE_INFO(state, courseInfo) {
      state.cultureCourseInfo = courseInfo;
    },
  },

  actions: {
    loadAllCultureCourses({ commit }, { page = 1, filters = {} } = {}) {
      return fetchAllCultureCourses({ page, ...filters })
        .then((response) => {
          const coursesWithBackground = {
            ...response.data,
            data: response.data.data.map((course, index) => ({
              ...course,
              background: generateRandomGradient(index),
            })),
          };
          commit("SET_ALL_CULTURE_COURSES", coursesWithBackground);
        })
        .catch((error) => {
          console.error("Ошибка загрузки культурных курсов:", error);
          return Promise.reject(error);
        });
    },

    loadCultureCourseInfo({ commit }, courseId) {
      return fetchCultureCourseInfo(courseId)
        .then((response) => {
          commit("SET_CULTURE_COURSE_INFO", response.data.course_info);
        })
        .catch((error) => {
          console.error(
            "Ошибка загрузки информации о культурном курсе:",
            error
          );
          return Promise.reject(error);
        });
    },
  },

  getters: {
    getAllCourses: (state) => state.allCultureCourses,
    getPagination: (state) => state.allCultureCourses.pagination,
    getCourseInfo: (state) => state.cultureCourseInfo,
    getGradients: (state) => state.gradients,
  },
};
